import { useEffect, useState } from "react";
import { apiClient } from "./api-client";
import { useAuth } from "./auth-context";

export interface ClubInfo {
  name: string;
  logoUrl: string | null;
}

const CLUB_INFO_REFRESH_EVENT = "club-info:refresh";

export function useClubInfo(): ClubInfo | null {
  const { user } = useAuth();
  const [clubInfo, setClubInfo] = useState<ClubInfo | null>(null);
  const activeClubId = user?.club?.id ?? null;

  useEffect(() => {
    const loadClubInfo = () => {
      apiClient
        .getMyClubs()
        .then((clubs) => setClubInfo(clubs.find((c) => String(c.id) === String(activeClubId)) ?? clubs[0] ?? null))
        .catch(() => setClubInfo(null));
    };

    loadClubInfo();
    window.addEventListener(CLUB_INFO_REFRESH_EVENT, loadClubInfo);

    return () => {
      window.removeEventListener(CLUB_INFO_REFRESH_EVENT, loadClubInfo);
    };
  }, [activeClubId]);

  return clubInfo;
}
